<div class="flex flex-col gap-8 text-center">
  <div class="group mb-4 font-sans text-base font-normal">
    {{ 'act.authentication-finished-page.description' | translate }}
  </div>
  <pay-button-primary (click)="redirectDashboard()" [rounded]="'rounded-lg'">
    {{ 'act.authentication-finished-page.button-label' | translate }}
  </pay-button-primary>
</div>
